import {enumType} from '../common/enumType';

const ftpLibrary = (id: string, display: string, supportsAcceleration: boolean) => ({
   id,
   display,
   supportsAcceleration,
});

export const FtpLibrary = enumType({
   JSCAPE_87: ftpLibrary('Jscape87', '6.0', false),
   JSCAPE_90: ftpLibrary('Jscape90', '6.1', true),
   JSCAPE_92: ftpLibrary('Jscape92', '7.2', true),
   JSCAPE_2015: ftpLibrary('Jscape2015', '', true),
});
